var React = require('react');

function FbIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 9.5C19 4.25184 14.7446 0 9.5 0C4.25184 0 0 4.25184 0 9.5C0 14.2405 3.47284 18.1711 8.01562 18.883V12.2467H5.60322V9.50059H8.01562V7.40644C8.01562 5.02609 9.43172 3.71153 11.6025 3.71153C12.6421 3.71153 13.7305 3.89678 13.7305 3.89678V6.23438H12.5305C11.3525 6.23438 10.9844 6.96766 10.9844 7.71875V9.5H13.6188L13.1955 12.2461H10.9844V18.8824C15.5236 18.1705 19 14.2399 19 9.49941V9.5Z"}));
}

FbIcon.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = FbIcon;

FbIcon.default = FbIcon;
